import { forwardRef } from 'react';
import ReactQuill, { EmitterSource } from 'react-quill-new';
import 'react-quill-new/dist/quill.bubble.css';
import './richTextTheme.css';

import { quillModules } from 'constants/quillModules';
import { sanitizeHtml } from 'util/richText';
import 'util/quillBubbleCustomTheme';

type Props = {
  onBlur?: () => void;
  onChange: (content: string) => void;
  onFocus?: () => void;
  value: string;
};

const RichText = forwardRef<ReactQuill, Props>(function RichText(
  { onBlur, onChange, onFocus, value },
  ref,
) {
  return (
    <ReactQuill
      ref={ref}
      className="w-full rounded-lg border border-gray-d-300 shadow-sm text-gray-d-900 focus-within:border-transparent focus-within:outline focus-within:outline-2 focus-within:outline-primary-d-600"
      modules={quillModules}
      onBlur={() => onBlur?.()}
      onChange={(content, _delta, source: EmitterSource) => {
        if (source === 'user') {
          onChange(sanitizeHtml(content));
        }
      }}
      onFocus={() => onFocus?.()}
      theme="glass-bubble"
      value={sanitizeHtml(value)}
    />
  );
});

export default RichText;
